import { FC } from "react";

import { Typography } from "@digital-services/ui";

interface Props {
  text: string;
}

export const BasicTwoParagraphs: FC<Props> = props => {
  const { text } = props;

  return (
    <>
      <Typography className="self-center">{text}</Typography>
      <div className="flex justify-start gap-2">
        <Typography className="self-center">{""}</Typography>
      </div>
    </>
  );
};
